import './LoadingTable.css'

const LoadingPage = ({colSpan}) => {

	return (
		<>
		  	<div className="spinner !m-0">
		  	</div>
		  	<span className="text-xs">Loading...</span>
		</>
	)

}

export default LoadingPage